module.exports = __webpack_public_path__ + "static/media/temp_43.28250037.jpg";